import React, { useState } from 'react';

export default function ChatInput({ onSendMessage, isTyping, disabled }) {
  const [inputVal, setInputVal] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputVal.trim() || isTyping || disabled) return;

    onSendMessage(inputVal);
    setInputVal('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form className="msq-chat-input-bar" onSubmit={handleSubmit}>
      <input
        type="text"
        className="msq-chat-input"
        placeholder="Type your question..."
        value={inputVal}
        onChange={(e) => setInputVal(e.target.value)}
        onKeyDown={handleKeyDown}
        maxLength={1000}
        disabled={disabled}
        aria-label="Ask MSquare Assistant"
      />
      <button
        type="submit"
        className="msq-chat-send-btn"
        disabled={!inputVal.trim() || isTyping || disabled}
        aria-label="Send message"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
        </svg>
      </button>
    </form>
  );
}
